import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  snackbarState: false,
};

export const snackbarSlice = createSlice({
  name: "SNACKBAR",
  initialState,
  reducers: {
    SHOW_SNACKBAR: (state, action) => {
      state.snackbarState = action.payload;
    },
  },
});

export const { SHOW_SNACKBAR } = snackbarSlice.actions;
export default snackbarSlice.reducer;
